/* [PATCH prenos-pdf-nastavitev v1] Nastavitve -> Splosne nastavitve -> "Priloga PDF pri prenosih".
   Nastavi PRIVZETO stanje kljukice "Prilozi PDF" na strani Prenosi (VOD / Opal-Pantheon).
   Uporabnik jo lahko za posamezen prenos se vedno rocno obrne.
   Shranjuje se SPROTI (PUT /profil/{cid} samo s tem poljem; backend ima exclude_none). */
import { useState, useEffect } from 'react';
import { api } from '../../lib/api';
import { Paperclip } from 'lucide-react';

export function PrenosPdfKartica({ companyId }: { companyId: string }) {
  const [vklop, setVklop] = useState(true);   // privzetek = dosedanje vedenje
  const [spor, setSpor] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!companyId) return;
    api.get(`/profil/${companyId}`)
      .then(r => setVklop(r.data?.prenos_prilozi_pdf !== false))
      .catch(() => {});
  }, [companyId]);

  const preklopi = async () => {
    if (busy) return;
    const novo = !vklop;
    setBusy(true); setSpor('');
    try {
      await api.put(`/profil/${companyId}`, { prenos_prilozi_pdf: novo });
      setVklop(novo);
      setSpor(novo ? 'Shranjeno: priloga je privzeto vklopljena.'
                   : 'Shranjeno: priloga je privzeto izklopljena.');
    } catch {
      setSpor('Napaka pri shranjevanju.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-800 p-6 max-w-2xl">
      <div className="flex items-center gap-3 mb-1">
        <div className="w-10 h-10 rounded-xl bg-blue-50 dark:bg-blue-950 flex items-center justify-center text-blue-600 dark:text-blue-400">
          <Paperclip className="w-5 h-5" />
        </div>
        <div>
          <h2 className="font-semibold text-gray-900 dark:text-white">Priloga PDF pri prenosih</h2>
          <p className="text-xs text-gray-500 dark:text-gray-400">{/* [PATCH prenos-pdf-besedilo v1] prvi stavek odstranjen */}
            Priloga vgradi PDF vsakega dokumenta v XML (blok Sken). Za posamezen prenos jo lahko kadarkoli ročno obrneš.
          </p>
        </div>
      </div>
      <div className="mt-4 flex items-start gap-3">
        <button
          type="button"
          onClick={preklopi}
          disabled={busy}
          role="switch"
          aria-checked={vklop}
          className={`relative w-12 h-6 rounded-full transition-colors shrink-0 ${vklop ? 'bg-emerald-500' : 'bg-gray-300 dark:bg-gray-700'} ${busy ? 'opacity-60' : ''}`}
        >
          <span className={`absolute top-0.5 w-5 h-5 rounded-full bg-white transition-all ${vklop ? 'left-6' : 'left-0.5'}`} />
        </button>
        <div>
          <div className="text-sm font-medium text-gray-900 dark:text-white">
            {vklop ? 'Priloži PDF je privzeto vklopljeno' : 'Priloži PDF je privzeto izklopljeno'}
          </div>
          <div className="text-xs text-gray-500 mt-1">
            {vklop ? 'Prenesene datoteke bodo vsebovale PDF prilogo (večje datoteke).'
                   : 'Prenesene datoteke bodo brez PDF prilog; kljukico lahko vklopiš ob prenosu.'}
          </div>
          {spor && <p className="text-[11px] text-gray-500 mt-1">{spor}</p>}
        </div>
      </div>
      <p className="text-[11px] text-gray-500 mt-3">Nastavitev se shrani sproti (neodvisno od gumba Shrani).</p>
    </div>
  );
}
